import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Alert,
} from "@mui/material";
import {postData} from "../services/Request"
import { toast } from 'react-toastify';

export default function SupportPage() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const payload = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };
   
    try {
      const res = await postData("api/auth/support", payload);

      if (res.status === true) {
        toast.success(res.message || "Your query has been received. We will get back to you soon.");
        setFormData({ name: "", email: "", message: "" });
        setLoading(false)
      }
      if (res.status === false){
        toast.error(res?.message || "Something went wrong. Please try again.");
        setLoading(false)
      }
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error("Something went wrong. Please try again.");
      setLoading(false)
    }
  };


  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
      }}
    >
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          mb: 1,
          textAlign: "center",
          fontSize: { xs: "1.6rem", md: "2rem" },
        }}
      >
        Looking For Support?
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "gray",
          mb: 4,
          textAlign: "center",
          maxWidth: "500px",
          fontSize: { xs: "0.9rem", md: "1rem" },
        }}
      >
        Got a Question? We'd love to hear from you. Send us a message and we
        will respond to you as soon as possible.
      </Typography>


      {/* Form Container */}
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 4 },
          borderRadius: 3,
          width: { xs: "80%", md: "100%" },
          background: "linear-gradient(135deg, #f9f9f9, #ffffff)",
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            required
          />

          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            disabled={loading}
            sx={{
              mt: 2,
              background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
              borderRadius: "8px",
              fontWeight: "bold",
              "&:hover": {
                background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
              },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Send Message"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
